import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadiologicalProgressionAsbestosisComponent } from './radiological-progression-asbestosis.component';
import { KButtonModule } from 'ng-k-button';
import { KIconModule } from 'ng-k-icon';
import { KNotificationsModule } from 'ng-k-notifications';
import { KModalModule } from 'ng-k-modal';
import { KFormModule } from 'ng-k-form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KCardModule } from 'ng-k-card';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomBreadcrumbModule } from '../../common/custom-breadcrumb/custom-breadcrumb.module';

@NgModule({
  declarations: [
    RadiologicalProgressionAsbestosisComponent
  ],
  imports: [
    CommonModule,
    KButtonModule,
    KIconModule,
    KNotificationsModule,
    KModalModule,
    KFormModule,
    ReactiveFormsModule,
    FormsModule,
    KCardModule,
    NgbAccordionModule,
    CustomBreadcrumbModule
  ]
})
export class RadiologicalProgressionAsbestosisModule { }